import React from 'react';
import { FilterDropdown } from './FilterDropdown';
import { useTranslation } from 'react-i18next';

interface MonthFilterDropdownProps {
  selectedMonths: string[];
  onMonthsChange: (months: string[]) => void;
  onApplyFilter: () => void;
  onClearFilter: () => void;
  isFilterApplied: boolean;
}

export const MonthFilterDropdown: React.FC<MonthFilterDropdownProps> = ({
  selectedMonths,
  onMonthsChange,
  onApplyFilter,
  onClearFilter,
  isFilterApplied,
}) => {
  const { t } = useTranslation();

  const availableMonths = [
    t('commons.months.december'),
    t('commons.months.november'),
    t('commons.months.october'),
    t('commons.months.september'),
    t('commons.months.august'),
    t('commons.months.july'),
    t('commons.months.june'),
    t('commons.months.may'),
    t('commons.months.april'),
    t('commons.months.march'),
    t('commons.months.february'),
    t('commons.months.january'),
  ];


  return (
    <FilterDropdown
      label={t('history.documents.filters.month')}
      selectedItems={selectedMonths}
      availableItems={availableMonths}
      onItemsChange={onMonthsChange}
      onApplyFilter={onApplyFilter}
      onClearFilter={onClearFilter}
      isFilterApplied={isFilterApplied}
    />
  );
};
